import { z } from "zod";
import { uuid } from "./common.js";
export const chatRole = z.enum(["user", "assistant"]);
/**
 * One document per conversation (D-21). `documentId` is required, not nullable --
 * the earlier ambiguity here would have surfaced mid-build as an hour of
 * indecision. Cross-document chat is a later `= ANY($2)` change, not a rewrite.
 */
export const chatRequest = z.object({
    documentId: uuid,
    sessionId: uuid.optional(),
    question: z.string().min(1).max(2000),
});
/** A retrieved chunk, surfaced to the UI as citation [n]. */
export const source = z.object({
    n: z.number().int().positive(),
    chunkId: uuid,
    pageFrom: z.number().int().positive(),
    pageTo: z.number().int().positive(),
    snippet: z.string(),
    score: z.number(),
});
export const chatMessage = z.object({
    id: uuid,
    role: chatRole,
    content: z.string(),
    createdAt: z.string().datetime(),
    sources: z.array(source).default([]),
});
export const chatSession = z.object({
    id: uuid,
    documentId: uuid,
    title: z.string(),
    createdAt: z.string().datetime(),
});
/* ------------------------------------------------------------------ *
 * SSE wire protocol (§2.6)
 *
 * `meta` arrives before the model is called, which is both a UX win (citation
 * chips render immediately) and how the stream stays alive past Cloudflare's
 * ~100s idle cutoff (W-1). `:ping` comments every 15s cover the rest.
 * ------------------------------------------------------------------ */
export const sseMeta = z.object({
    sessionId: uuid,
    sources: z.array(source),
});
export const sseToken = z.object({ text: z.string() });
export const sseDone = z.object({
    messageId: uuid,
    finishReason: z.enum(["stop", "length", "no_context", "aborted"]),
});
export const sseError = z.object({
    code: z.string(),
    message: z.string(),
});
export const SSE_EVENTS = ["meta", "token", "done", "error"];
//# sourceMappingURL=chat.js.map